import {Component, OnInit} from '@angular/core';
import {RestApiService} from '../rest-api.service';
import {ActivatedRoute} from '@angular/router';
import {MessageService} from '../message.service';

@Component({
    selector: 'app-activation',
    templateUrl: './activation.component.html',
    styleUrls: ['./activation.component.css']
})
export class ActivationComponent implements OnInit {
    private respObject: any;

    constructor(private _rest: RestApiService, private actRoute: ActivatedRoute, private messageService: MessageService) {
    }

    ngOnInit(): void {
        // console.log()
        this.actRoute.queryParams.subscribe(params => {
            const ticket_no = params['ticket_no'];
            const clientId = params['clientId'];
            const encodedUserName = params['login_name'];
            let userName;
            if (encodedUserName) {
                userName = this.messageService.xorEncode(atob(encodedUserName), this.messageService.SECRET_TOKEN);
                this._rest.generateToken(clientId, userName).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        const data = this.respObject.details;
                        // console.log(JSON.stringify(data));
                        this.messageService.addSessionData(data.id, data.token , clientId);
                        window.location.href = location.origin + '/#/ticket/emailSearch?ticket_no=' + ticket_no ;
                    } else {
                        alert(this.respObject.errorMessage);
                    }
                }, (err) => {
                    // alert(this.messageService.SERVER_ERROR);
                });
            }
        });
    }

}
